import axios from 'axios'
import { GenericOrderBy } from '../../../components/_EOS/Table'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../../config/api'
import {
  VasRule,
  VasRuleUpdate,
  VasRuleCreate,
  VasRuleDetailCreate,
  VasRuleDetail,
  VasRuleDetailPatch,
  VasRuleOrderDetailCreate
} from '../../../interfaces/VasRule/VasRule'

export const getVasRuleList = (
  filters?: Filter[],
  page: number = 0,
  pageSize: number = 5,
  orderBy?: GenericOrderBy<VasRule>
) => {
  const url = new URL(`${ApiConfig.VasRuleApi}`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const postVasRule = (dto: VasRuleCreate) => {
  const url = new URL(`${ApiConfig.VasRuleApi}`)

  return axios.post(url.toString(), dto)
}

export const getVasRule = (vasRuleId: number) => {
  const url = new URL(`${ApiConfig.VasRuleApi}/${vasRuleId}`)

  return axios.get(url.toString())
}

export const patchVasRule = (vasRuleId: number, dto: VasRuleUpdate) => {
  const url = new URL(`${ApiConfig.VasRuleApi}/${vasRuleId}`)
  return axios.patch(url.toString(), dto)
}

export const deleteVasRule = (vasRuleId: number) => {
  const url = new URL(`${ApiConfig.VasRuleApi}/${vasRuleId}`)
  return axios.delete(url.toString())
}

export const getVasRuleDetailList = (
  vasRuleId: number,
  page: number,
  pageSize: number,
  orderBy?: GenericOrderBy<VasRuleDetail>
) => {
  const url = new URL(`${ApiConfig.VasRuleDetailApi}`)

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  url.searchParams.set('VasRuleId', vasRuleId.toString())

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const postVasRuledetail = (dto: VasRuleDetailCreate) => {
  const url = new URL(`${ApiConfig.VasRuleDetailApi}`)

  return axios.post(url.toString(), dto)
}

export const deleteVasRuleDetail = (vasRuleDetailId: number) => {
  const baseUrl = ApiConfig.VasRuleDetailApi
  const url = `${baseUrl}/${vasRuleDetailId}`

  return axios.delete(url)
}

export const patchVasRuledetail = (id: number, dto: VasRuleDetailPatch) => {
  const url = new URL(`${ApiConfig.VasRuleDetailApi}/${id}`)

  return axios.patch(url.toString(), dto)
}

export const vasRuleUpdateState = (id: number) => {
  const url = new URL(`${ApiConfig.VasRuleApi}/VasRuleUpdateState/${id}`)

  return axios.post(url.toString())
}

export const getVasRuleSku = (
  skuId: number,
  vasRuleId?: number,
  page = 0,
  pageSize = 25
) => {
  const url = new URL(`${ApiConfig.VasRuleSkuApi}`)

  url.searchParams.set('SkuId', skuId.toString())

  if (vasRuleId !== undefined) {
    url.searchParams.append('vasRuleId', vasRuleId.toString())
  }

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  return axios.get(url.toString())
}

export const createVasRuleOrderDetail = (
  vasRuleOrderDetailCreateDto: VasRuleOrderDetailCreate[]
) => {
  const url = new URL(ApiConfig.VasRuleOrderDetailApi)
  return axios.post(url.toString(), vasRuleOrderDetailCreateDto)
}
